export default function percentFormatter (value) {
  if (value > 0) {
    const formatedValue = '+' + value.toFixed(2)
    return formatedValue
  }
  return value.toFixed(2)
}
